<template>
    <v-container fluid>
        <v-card>
            <v-card-title>
                <v-row dense align="center">
                    <v-col cols="12" md="8">
                        <div class="text-subtitle-1 font-weight-bold">
                            <v-icon left color="primary">notifications_active</v-icon>Notificaciones y mensajes
                        </div>
                        <div class="text-caption grey--text text--darken-1">
                            Correos a los participantes cuando su certificado queda disponible, cola de envío con cupo diario
                            y avisos en la campana de la aplicación.
                        </div>
                    </v-col>
                </v-row>
            </v-card-title>

            <v-tabs v-model="pestana" background-color="transparent" color="primary" show-arrows>
                <v-tab v-for="p in pestanas" :key="p.clave" :href="'#' + p.clave">
                    <v-icon small left>{{ p.icono }}</v-icon>{{ p.texto }}
                </v-tab>
            </v-tabs>
            <v-divider></v-divider>

            <v-tabs-items v-model="pestana" touchless>
                <v-tab-item value="plantillas">
                    <plantillas-correo v-if="listo"/>
                </v-tab-item>
                <v-tab-item value="envios">
                    <envios v-if="listo"/>
                </v-tab-item>
                <v-tab-item value="ajustes">
                    <ajustes v-if="listo"/>
                </v-tab-item>
                <v-tab-item value="mensajes">
                    <mensajes v-if="listo"/>
                </v-tab-item>
            </v-tabs-items>
        </v-card>
    </v-container>
</template>

<script>
import Auth from "@/services/auth";
import PlantillasCorreo from "./PlantillasCorreo.vue";
import Envios from "./Envios.vue";
import Ajustes from "./Ajustes.vue";
import Mensajes from "./Mensajes.vue";

/**
 * Administración → Notificaciones. Cada pestaña carga sus propios datos y
 * recibe sus permisos del API; la pestaña activa se conserva en la URL (?pestana=).
 */
export default {
    name: "AdministracionNotificaciones",
    components: {PlantillasCorreo, Envios, Ajustes, Mensajes},
    data() {
        return {
            listo: false,
            pestana: this.$route.query.pestana || "plantillas",
            pestanas: [
                {clave: "plantillas", texto: "Plantillas", icono: "mark_email_read"},
                {clave: "envios", texto: "Envíos", icono: "outgoing_mail"},
                {clave: "ajustes", texto: "Ajustes", icono: "tune"},
                {clave: "mensajes", texto: "Mensajes", icono: "campaign"},
            ],
        }
    },
    watch: {
        pestana(valor) {
            if (this.$route.query.pestana !== valor) {
                this.$router.replace({query: {...this.$route.query, pestana: valor}}).catch(() => {});
            }
        },
    },
    created() {
        Auth.checkPermisos("/administracion/notificaciones").then(() => {
            this.listo = true;
        });
    },
}
</script>
